const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/collections/$id/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { getQueryClient } from "@/lib/client";
import { getFetchedQuery } from "@/lib/get-fetched-query";
import i18n from "@/lib/i18n";
import { getCollection } from "@/queries/collection";
import { dehydrate } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/{-$locale}/collections/$id/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    params,
    context
  }) => {
    const {
      id
    } = params;
    const {
      queryClient,
      country
    } = context;
    await queryClient.prefetchInfiniteQuery({
      queryKey: ["collection", {
        id,
        country,
        limit: 20
      }],
      queryFn: ({
        pageParam
      }) => getCollection({
        slug: id,
        limit: 20,
        page: pageParam as number,
        country: country ?? "US"
      }).catch(() => null),
      initialPageParam: 1,
      getNextPageParam: (lastPage: Collections | null, allPages: (Collections | null)[]) => {
        if (!lastPage) return undefined;
        if (lastPage.page * lastPage.limit + 20 > lastPage.total) {
          return undefined;
        }
        return allPages?.length + 1;
      }
    });
    return {
      id,
      dehydratedState: dehydrate(queryClient),
      country
    };
  },
  head: ctx => {
    const {
      params
    } = ctx;
    const queryClient = getQueryClient();
    if (!ctx.loaderData) {
      return {
        meta: [{
          title: i18n.t("collections.errors.notFound"),
          description: i18n.t("collections.errors.notFound")
        }]
      };
    }
    const collectionPages = getFetchedQuery<{
      pages: Collections[];
    }>(queryClient, ctx.loaderData.dehydratedState, ["collection", {
      id: params.id,
      country: ctx.loaderData.country,
      limit: 20
    }]);
    const collection = collectionPages?.pages[0];
    if (!collection) {
      return {
        meta: [{
          title: i18n.t("collections.errors.notFound"),
          description: i18n.t("collections.errors.notFound")
        }]
      };
    }
    return {
      meta: [{
        title: i18n.t("collections.meta.title", {
          title: collection.title
        })
      }, {
        name: "description",
        content: i18n.t("collections.meta.description", {
          title: collection.title
        })
      }, {
        name: "og:title",
        content: i18n.t("collections.meta.title", {
          title: collection.title
        })
      }, {
        name: "og:description",
        content: i18n.t("collections.meta.description", {
          title: collection.title
        })
      }, {
        property: "twitter:title",
        content: i18n.t("collections.meta.title", {
          title: collection.title
        })
      }, {
        property: "twitter:description",
        content: i18n.t("collections.meta.description", {
          title: collection.title
        })
      }]
    };
  }
});